import React, { useState, useEffect, useRef, forwardRef, Fragment } from "react";
import { useHistory } from "react-router-dom";
import {TextField,
        Grid,
        Box,
        Button,
        CircularProgress,
        Tabs,
        Tab,
        AppBar,
        Typography,
        InputAdornment,
        MenuItem,
        Dialog,
        DialogActions,
        DialogContent,
        DialogContentText,
        DialogTitle,
        IconButton,
        Switch,
        ButtonBase,
        Tooltip,
        Badge
} from "@material-ui/core";
import PropTypes from 'prop-types';
//import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import { Link } from '../../components/Wrappers'
import {DropzoneArea} from 'material-ui-dropzone'
import useStyles from './styles';
import classnames from "classnames";
import ttAPI from '../../api/ttAPI';
import config from '../../config';
import Widget from '../../components/Widget';
import { sendNotification } from "../../context/UserContext";

import {CalendarToday as CalendarTodayIcon,
        Send as SendIcon,
        GetApp as GetAppIcon,
        ListAlt as ListAltIcon,
        AssignmentTurnedIn as AssignmentTurnedInIcon,
        CardMembership as CardMembershipIcon,
        FileCopy as FileCopyIcon,
        Receipt as ReceiptIcon,
        DeleteForever as DeleteForeverIcon,
        Pageview as PageviewIcon,
        Replay as ReplayIcon,
        Chat as  ChatIcon,
        Edit as EditIcon,
        History as HistoryIcon,
        Check as CheckIcon,
        PictureAsPdf as PictureAsPdfIcon,
        Publish as PublishIcon,
        Delete as DeleteIcon,
        Description as DescriptionIcon
} from '@material-ui/icons';
// localStorage
import { useLocalStorage } from 'usehooks-ts'

import enNZ from 'date-fns/locale/en-NZ'
import DatePicker, { registerLocale } from "react-datepicker";
import SelectCustomer from '../../components/Customer/SelectCustomer';
import UpdateCustomer from '../../components/Customer/UpdateCustomer';
import SelectSite from '../../components/Site/SelectSite';
import UpdateSite from '../../components/Site/UpdateSite';
import JobDetails from '../../components/JobDetails/JobDetails';
import SelectTechnicians from '../../components/Technician/SelectTechnicians';
import './EditJob.css'
import "react-datepicker/dist/react-datepicker.css";
import JobCompletion from '../../components/JobCompletion/JobCompletion';
import JobReopen from '../../components/JobReopen/JobReopen';
import JobReportEmail from '../../components/JobReportEmail/JobReportEmail';
import JobConfirmation from '../../components/JobConfirmation/JobConfirmation';
import CustomerDownloadCSVConfirmation from '../../components/CustomerDownloadCSVConfirmation/CustomerDownloadCSVConfirmation';
import SiteRetests from '../../components/SiteRetest/SiteRetests';
import JobHistories from '../../components/JobHistories/JobHistories';

// logo
import teams from "../../images/teams.png";

registerLocale('en-NZ', enNZ);

const EditJob = forwardRef((props, ref) => {
//export default function CreateSite(props, ref) {
    // global
    const classes = useStyles();
    const history = useHistory();

    const completeRef = useRef(null);
    const completeCalendarRef = useRef(null);

    const [locationState, setLocationState] = useState(props.location.state);
    const [paramsId, setParamsId] = useState(props.match.params.id);
    const [job, setJob] = useState(undefined);

    const [isSelectCustomerValid, setIsSelectCustomerValid] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(undefined);
    const [isSelectSiteValid, setIsSelectSiteValid] = useState(false);
    const [selectedSite, setSelectedSite] = useState(undefined);
    const createJobDetailsRef = useRef(null);
    const selectTechniciansRef = useRef(null);
    const [isCreateJobDetailsValid, setIsCreateJobDetailsValid] = useState(false);
    const [isSelectTechniciansValid, setIsSelectTechniciansValid] = useState(true);
    const [workers, setWorkers] = useState([]);
    const [selectedCompleted, setSelectedCompleted] = React.useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isConfirming, setIsConfirming] = useState(false);
    //const [selectedDate, handleDateChange] = useState(new Date());
    const [siteTabValue, setSiteTabValue] = useState(0);
    const [customerTabValue, setCustomerTabValue] = useState(0);
    const [completeFocused, setCompleteFocused] = React.useState(false);
    var currentCompleteValue = null;

    const jobWidgetRef = useRef(null);
    const jobConfirmationRef = useRef(null);
    const [jobConfirmationIsOpen, setJobConfirmationIsOpen] = useState(false);
    const jobCompletionRef = useRef(null);
    const [jobCompletionIsOpen, setJobCompletionIsOpen] = useState(false);
    const jobReopenRef = useRef(null);
    const [reopenJobIsOpen, setReopenJobIsOpen] = useState(false);
    const [emailIsOpen, setEmailIsOpen] = useState(false);
    const [email, setEmail] = useState({
      job_id: -1,
      message: '',
      emails: [],
      customer_name: '',
      attach_certificate: true,
      attach_invoice_report: true,
      date: '',
    });
    const jobReportEmailsRef = useRef(null);
    const [isCopyingJob, setIsCopyingJob] = useState(false);
    const [isDeletingJob, setIsDeletingJob] = useState(false);
    const [openDeleteJobDialog, setOpenDeleteJobDialog] = useState(false);
    const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    const [originalJobConfirmed, setOriginalJobConfirmed] = useState(false);
    const [canSendJobSheet, setCanSendJobSheet] = useState(false);
    const [testScopesDirty, setTestScopesDirty] = useState(1);
    const mounted = useRef(true);
    const customerDownloadCSVConfirmationRef = useRef(null);
    const [oldJobId, setOldJobId] = useState(-1);
    const siteRetestsRef = useRef(null);
    const [displaySiteAssetsExpiryByMonth, setDisplaySiteAssetsExpiryByMonth] = useLocalStorage('display_site_assets_expiry_by_month_in_job', true)

    const [openDeleteReportDialog, setOpenDeleteReportDialog] = useState(false);
    const [aboutToDeleteReport, setAboutToDeleteReport] = useState({id:0, name:''});
    const [isDeletingReport, setIsDeletingReport] = useState(false);
    const [reportsLimit, setReportsLimit] = useState(2);
    const [isUploading, setIsUploading] = useState(false);
    const [fileObjects, setFileObjects] = useState([]);
    const [reportStatus, setReportStatus] = useState({pdf: false,doc: false});

    const [qualifiedTechWarningRequired, setQualifiedTechWarningRequired] = useState(false);

    const hasThermal = job?.testing_scopes?.some(scope => {
      if (typeof scope === "object" && scope !== null && "name" in scope) {
        return scope.name === "Thermal";
      }
      return false;
    }) ?? false;

    function TabPanel(props) {
      const { children, value, index, ...other } = props;

      return (
        <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
        >
          {value === index && (
            <Box p={3}>
              <Typography component="div">{children}</Typography>
            </Box>
          )}
        </div>
      );
    }

    TabPanel.propTypes = {
      children: PropTypes.node,
      index: PropTypes.any.isRequired,
      value: PropTypes.any.isRequired,
    };

    function a11yProps(index) {
      return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
      };
    }

    useEffect(() => {//console.log('useeffect completeFocused:',completeFocused);
      if (completeCalendarRef !== undefined && completeCalendarRef !== null &&
        completeCalendarRef.current !== undefined && completeCalendarRef.current !== null) {
        completeCalendarRef.current.setOpen(completeFocused);
      }
    },[completeFocused]);

    useEffect(() => {//console.log('useeffect completeFocused:',completeFocused);
      //console.log('job changed', job);
    },[job]);

    useEffect(() => {
        const jobId = locationState === undefined ? paramsId : locationState.jobId;

        if (jobId !== undefined && jobId > 0) {
            fetchData(jobId);
        }

        return () => {
          mounted.current = false;
        };
    },[locationState, paramsId]);

    useEffect(() => {
      const jobId = locationState === undefined ? paramsId : locationState.jobId;
        if (jobId >= 0 && jobConfirmationIsOpen) {
          triggerOpenJobConfirmation(jobId);
          setJobConfirmationIsOpen(false);
        }
    },[jobConfirmationIsOpen]);

    useEffect(() => {
      const jobId = locationState === undefined ? paramsId : locationState.jobId;
        if (jobId >= 0 && jobCompletionIsOpen) {
          triggerOpenJobCompletion(jobId);
          setJobCompletionIsOpen(false);
        }
    },[jobCompletionIsOpen]);

    useEffect(() => {
      const jobId = locationState === undefined ? paramsId : locationState.jobId;
        if (jobId >= 0 && reopenJobIsOpen) {
          triggerReopenJobCompletion(jobId);
          setReopenJobIsOpen(false);
        }
    },[reopenJobIsOpen]);

    function triggerOpenJobConfirmation(jobIdToConfirm) {
        jobConfirmationRef.current.openConfirmationPopup(jobIdToConfirm);
    }

    function triggerOpenJobCompletion(jobIdToComplete) {
        jobCompletionRef.current.openCompletionPopup(jobIdToComplete);
    }

    function triggerReopenJobCompletion(jobIdToComplete) {
        jobReopenRef.current.openReopenPopup(jobIdToComplete);
    }

    useEffect(() => {
        if (locationState !== undefined && locationState.jobId !== undefined ) {
            if (locationState.isFromBookJob) {
              sendNotification('success', `Success - Job ${locationState.jobId} Booked.`, classes);
            }
            else if (locationState.isFromCreateJob)  {
              sendNotification('success', `Success - Job ${locationState.jobId} Created.`, classes);
            }
        }
    },[locationState, sendNotification]);

    useEffect(() => {
      if (selectedCustomer !== undefined && selectedCustomer != null) {
        setJob({
          ...job,
          jsa_required: job !== null && job !== undefined && job.jsa_required !== null && job.jsa_required !== undefined ? job.jsa_required : selectedCustomer.jsa_required,
          microwave_only: job !== null && job !== undefined && job.microwave_only !== null && job.microwave_only !== undefined ? job.microwave_only : selectedCustomer.microwave_only
        });
      }
    },[selectedCustomer]);

    useEffect(() => {
      if (selectedSite !== undefined && selectedSite != null) {
        var testingScopes = job !== null && job !== undefined && job.testing_scopes !== null && job.testing_scopes !== undefined ? job.testing_scopes : selectedSite.testing_scopes;
        var isJobTestingScopesAvailable = testingScopes !== null && testingScopes !== undefined;
        setJob({
          ...job,
          testing_scopes: testingScopes,
          // if job already have testing scopes saved then we don't need to get any extra notes from site
          testing_scope_other_notes: isJobTestingScopesAvailable ? job.testing_scope_other_notes : selectedSite.testing_scope_other_notes
        });
      }
    },[selectedSite]);

    async function fetchData(jobId) {

        const response = await ttAPI.loadJob(jobId);
        if (mounted.current && response !== undefined && response !== null) {
            //if(didMount){
                setJob(response);
                if (response.completed !== undefined && response.completed !== null && response.completed !== '') {
                    setSelectedCompleted(new Date(response.completed));
                }

                setOriginalJobConfirmed(response.confirmed);
            //}

            const customerLoaded = await ttAPI.getCustomerById(response.customer_id);
            //if(didMount){
                setSelectedCustomer(customerLoaded);
            //}

            const siteLoaded = await ttAPI.getSiteById(response.site_id);
            //if(didMount){
                setSelectedSite(siteLoaded);
            //}

            // check and save report status
            await checkReports(jobId);

            // if job opens in new tab then change the tab title
            if ((locationState === undefined || locationState === null ||
                locationState.jobId === undefined || locationState.jobId === null) &&
                customerLoaded !== undefined && customerLoaded !== null &&
                siteLoaded !== undefined && siteLoaded !== null) {
                document.title = `${response.id} ${customerLoaded.name} ${siteLoaded.name}`;
            }

            if (response.is_in_region) {
              const regionWorkersLoaded = await ttAPI.getActiveWorkersByRegion(response.franchise_id);
              //if(didMount){
                  setWorkers(regionWorkersLoaded);
              //}
            }
            else {
              const regionWorkersLoaded = await ttAPI.getActiveWorkers();
              //if(didMount){
                  setWorkers(regionWorkersLoaded);
              //}
            }

            // fetch last job id for site
            const lastRetest = await ttAPI.loadRetest(null, response.site_id);
            /*if (lastRetest && lastRetest !== null) {
                setOldJobId(lastRetest.job_id === null || lastRetest.job_id === undefined ? lastRetest.id : lastRetest.job_id);
            }*/
            if (lastRetest && lastRetest !== null && lastRetest.job_id !== null && lastRetest.job_id !== undefined) {
                setOldJobId(lastRetest.job_id);
            }
        }
    }

    function onSelectCustomer(customer) {
      setSelectedCustomer(customer);
      setJob({
        ...job,
        customer_id: customer === undefined || customer === null ? -1 : customer.id,
        jsa_required: customer === undefined || customer === null ? job.jsa_required : (job.jsa_required !== undefined && job.jsa_required !== null ? job.jsa_required : customer.jsa_required),
        microwave_only: customer === undefined || customer === null ? job.microwave_only : (job.microwave_only !== undefined && job.microwave_only !== null ? job.microwave_only : customer.microwave_only),
        approved_limit_type: customer === undefined || customer === null ? null : customer.approved_limit_type,
        approved_limit_value: customer === undefined || customer === null || customer.id !== job.customer_id ? null : job.approved_limit_value
      });
    }

    function onSelectCustomerFormUpdated(isValid) {
      setIsSelectCustomerValid(isValid);
    }

    function onSelectSite(site) {
      setSelectedSite(site);
      setJob({
        ...job,
        site_id: site === undefined || site === null ? -1 : site.id
      });
    }

    function onSelectSiteFormUpdated(isValid) {
      setIsSelectSiteValid(isValid);
    }

    function onCreateJobDetailsFormUpdated(isValid) {
        setIsCreateJobDetailsValid(isValid);
    }

    function onCreateJobDetailsUpdated(createdJob) {
        //setJob(job);
        setJob({
          ...job,
          start: createdJob.start,
          finish: createdJob.finish,
          code: createdJob.code,
          contact: createdJob.contact,
          instructions: createdJob.instructions,
          tag: createdJob.tag,
          franchise_id: createdJob.franchise_id,
          is_in_region: createdJob.is_in_region,
          has_important_instruction: createdJob.has_important_instruction,
          is_nfc: createdJob.is_nfc,
          is_cataloguing: createdJob.is_cataloguing,
          jsa_required: createdJob.jsa_required,
          microwave_only: createdJob.microwave_only,
          approved_limit_type: createdJob.approved_limit_type,
          approved_limit_value: createdJob.approved_limit_value,
          testing_scopes: createdJob.testing_scopes,
          testing_scope_other_notes: createdJob.testing_scope_other_notes
        });
    }

    function onJobDetailsCreated(updatedJob) {
      setJob({
        ...job,
        start: updatedJob.start,
        finish: updatedJob.finish,
        code: updatedJob.code,
        contact: updatedJob.contact,
        instructions: updatedJob.instructions,
        tag: updatedJob.tag,
        franchise_id: updatedJob.franchise_id,
        is_in_region: updatedJob.is_in_region,
        has_important_instruction: updatedJob.has_important_instruction,
        is_nfc: updatedJob.is_nfc,
        is_cataloguing: updatedJob.is_cataloguing,
        jsa_required: updatedJob.jsa_required,
        microwave_only: updatedJob.microwave_only,
        approved_limit_type: updatedJob.approved_limit_type,
        approved_limit_value: updatedJob.approved_limit_value,
        testing_scopes: updatedJob.testing_scopes,
        testing_scope_other_notes: updatedJob.testing_scope_other_notes
      });
    }

    async function onRegionSelected(regionId) {
      if (job.is_in_region && regionId > 0) {
        const response = await ttAPI.getActiveWorkersByRegion(regionId);
        setWorkers(response);
      }
      else {
        const response = await ttAPI.getActiveWorkers();
        setWorkers(response);
      }
      if (selectTechniciansRef.current) {
        selectTechniciansRef.current.updateLeaderWokersSelection(job.is_in_region);
      }
    }

    async function onIsInRegionSelected(isInRegionValue) {
      setJob({
        ...job,
        is_in_region: isInRegionValue === 'YES'
      });
       // is in region workers allowed - changed, need to repull the workers list
       if (isInRegionValue === 'YES' && job !== undefined && job !== null && job.franchise_id > 0) {
         const response = await ttAPI.getActiveWorkersByRegion(job.franchise_id);
         setWorkers(response);
       }
       else {
         const response = await ttAPI.getActiveWorkers();
         setWorkers(response);
       }
       if (selectTechniciansRef.current) {
         selectTechniciansRef.current.updateLeaderWokersSelection(isInRegionValue);
       }
    }

    function onSelectTechniciansFormUpdated(isValid) {
        setIsSelectTechniciansValid(isValid);
    }

    function onTechniciansSelected(workers) {
        setJob({
          ...job,
          workers: workers,
        });
    }

    function onLeaderSelected(leader) {
        setJob({
          ...job,
          leader: leader
        });
        setIsSelectTechniciansValid(true);
    }

    const disableSaveButton = () => {
      return (isSaving || isConfirming) || !(isSelectCustomerValid && isSelectSiteValid && isCreateJobDetailsValid && isSelectTechniciansValid);
    }

    const disableConfirmButton = () => {
      //return isConfirming || isSaving;
      return (isSaving || isConfirming) || !(isSelectCustomerValid && isSelectSiteValid && isCreateJobDetailsValid && isSelectTechniciansValid);
    }

    const handleConfirmJob = async() => {
        setIsConfirming(true);
        const jobToSend = job;
        if (jobToSend.workers) {
            jobToSend.workers = jobToSend.workers.map(worker => worker.id === undefined ? worker : worker.id);
        }
        if (jobToSend.testing_scopes !== undefined && jobToSend.testing_scopes !== null) {
            jobToSend.testing_scopes = jobToSend.testing_scopes.map(testing_scope => isNaN(testing_scope) ? testing_scope.id : testing_scope);
        }

        jobToSend.start = jobToSend.start.replace('T', ' ');
        jobToSend.finish = jobToSend.finish.replace('T', ' ');

        if (jobToSend.start.split(':').length == 2) {
            jobToSend.start = jobToSend.start.concat(':00');
        }

        if (jobToSend.finish.split(':').length == 2) {
            jobToSend.finish = jobToSend.finish.concat(':00');
        }

        jobToSend.work_completed = false;
        jobToSend.completed = null;
        jobToSend.confirmed = true;

        setIsConfirming(true);
        const response = await ttAPI.saveJob(jobToSend);
        if (response.id > 0) {
          setIsConfirming(false);
          if (localStorage.getItem('auto_open_teams_link_after_job_confirmation') === 'true') {
              openTeamChatWithJobCardLink();
          }
          ttAPI.sendJobSheet(job.id);
          setOriginalJobConfirmed(true);
          refreshData()
          sendNotification('success', `Success - Job ${response.id} Confirmed.`, classes);
        }
        else {
          setIsConfirming(false);
          sendNotification('error', `${response.error}`,classes );
        }
    }

    const handleFinish = async () => {
        const jobToSend = job;console.log('handleFinish',job)
        if (jobToSend.workers) {
            jobToSend.workers = jobToSend.workers.map(worker => worker.id === undefined ? worker : worker.id);
        }
        if (jobToSend.testing_scopes !== undefined && jobToSend.testing_scopes !== null) {
            jobToSend.testing_scopes = jobToSend.testing_scopes.map(testing_scope => isNaN(testing_scope) ? testing_scope.id : testing_scope);
        }
        jobToSend.start = jobToSend.start.replace('T', ' ');
        jobToSend.finish = jobToSend.finish.replace('T', ' ');

        if (jobToSend.start.split(':').length == 2) {
            jobToSend.start = jobToSend.start.concat(':00');
        }

        if (jobToSend.finish.split(':').length == 2) {
            jobToSend.finish = jobToSend.finish.concat(':00');
        }

        // if confirmed is already set
        if ((job.confirmed !== undefined && job.confirmed !== null && job.confirmed)) {
            if (jobToSend.completed !== undefined && jobToSend.completed !== null && jobToSend.completed !== '') {
                jobToSend.completed = jobToSend.completed.replace('T', ' ');
                if (jobToSend.completed.split(':').length == 2) {
                    jobToSend.completed = jobToSend.completed.concat(':00');
                }
            }
        }
        else {
            jobToSend.work_completed = false;
            jobToSend.completed = null;
        }



        setIsSaving(true);
        const response = await ttAPI.saveJob(jobToSend);
        if (response.id > 0) {
          setIsSaving(false);
          /*history.push({
            pathname: '/app/jobs',
            state:{jobId: response, isEdit: true}
          });*/
          var needToRefresh = true;
          if (canSendJobSheet) {
              if (localStorage.getItem('auto_open_teams_link_after_job_confirmation') === 'true') {
                  needToRefresh = false;
                  openTeamChatWithJobCardLink();
              }
              ttAPI.sendJobSheet(job.id);
          }
          else {
              setOriginalJobConfirmed(jobToSend.confirmed);
          }
          if (needToRefresh) {
              refreshData();
          }
          sendNotification('success', `Success - Job ${response.id} Updated.`, classes);
        }
        else {
          setIsSaving(false);
          sendNotification('error', `${response.error}`,classes );
        }
    }



    function handleSiteTabChange(event, newValue) {
      setSiteTabValue(newValue);
    }

    function handleCustomerTabChange(event, newValue) {
      setCustomerTabValue(newValue);
    }

    // triggered if value changes, but not save anywhere as the value here can be in-progress (if use keyboard)
    function handleChangeCompleted(d) {//console.log('handleChangeCompleted',d);
      currentCompleteValue = d;
    }

    function focusComplete(event) {//console.log('focuscomplete',event);
      setCompleteFocused(true);
    }

    function blurComplete(event) {//console.log('blurcomplete',event, currentCompleteValue);
      setCompleteFocused(false);
      saveCompleted();
    }

    // triggered if use keyboard
    function handleCompleteKeyPress(event) {
      //console.log('handleCompleteKeyPress',event.which, event.which === 9, currentCompleteValue, event);
      if (event.which === 9 || event.which === 13 || event.which === 27) {
        setCompleteFocused(false);
        saveCompleted();
      }
    }

    // triggered if select a date
    function handleSelectCompleted(d) {
      //console.log('handleSelectCompleted',d);
      saveCompleted();
    }

    function saveCompleted() {
      var d = currentCompleteValue !== undefined && currentCompleteValue !== null ? new Date(currentCompleteValue) : null;
      if (d !== null) {
        let [date, month, year] = d.toLocaleDateString('en-NZ').split("/")
        let [hour, minute] = d.toLocaleTimeString('en-NZ').slice(0,7).split(":")
        setJob({
          ...job,
          completed: `${year}-${month}-${date} ${d.toLocaleTimeString('en-NZ').toLowerCase().includes('am') ? hour : (parseInt(hour) == 12 ? 12 : parseInt(hour)+12)}:${minute}`,
        });
        setSelectedCompleted(new Date(currentCompleteValue));
        currentCompleteValue = d;
      }
    }

    function getSiteName() {
      return selectedSite !== undefined && selectedSite !== null ? selectedSite.name : '';
    }

    const handleOpenConfirmJob = () => {
      setJobConfirmationIsOpen(true);
    };

    const handleOpenCompleteJob = () => {
      setJobCompletionIsOpen(true);
    };

    const handleOpenReopenJob = () => {
      setReopenJobIsOpen(true);
    };

    const openViewAssets = () => {
      window.open(
      `${config.clientApi}/view_assets.jsp?id=${job.id}`,
      '_blank'
      );
      jobWidgetRef.current.closeWidgetMoreMenu();
    }

    function downloadCustomerAssetsCSV() {
      customerDownloadCSVConfirmationRef.current.openConfirmationPopup(job.customer_id, selectedCustomer !== undefined && selectedCustomer !== null ? selectedCustomer.name : '');
      jobWidgetRef.current.closeWidgetMoreMenu();
    }

    function downloadInvoicePdf() {
      window.open(
      `${config.clientApi}/reports/asset_testing.pdf?invf=-1&jobid=${job.id}`,
      '_blank'
      );
    }

    function downloadFailedReport() {
      window.open(
      `${config.clientApi}/report/failed_job_report?jobid=${job.id}`,
      '_blank'
      );
    }

    function downloadJobIssuesReport() {
      window.open(
      `${config.clientApi}/report/job_issues_report?jobid=${job.id}`,
      '_blank'
      );
    }

    const openInvoiceSummary = () => {
      window.open(
      `${config.adminApi}/#/app/invoice/summary/${job.id}`,
      '_blank'
      );
      handleClose();
    }

    const openTeamChat = async () => {
      const emails = await ttAPI.getJobWorkerEmails(job.id);

      if (emails !== null && emails !== undefined && emails !== '' && emails !== 'null') {
        window.open(
        `${config.teamChatUrl.replace('<USERS>', emails).replace('<TOPIC_NAME>',`Job%20${job.id}%20Chat`)}`,
        '_blank'
        );
      }
      else {
        sendNotification('error','Cannot open a team chat as there are no technicians are assigned to the job.', classes);
      }

      handleClose();
    }

    const openTeamChatWithJobCardLink = async () => {
      var emails = await ttAPI.getJobWorkerEmails(job.id);
      if (emails === null || emails === undefined || emails === 'null') {
        emails = job.emails;
      }// todo emails
      if (emails !== null && emails !== undefined && emails !== '' && emails !== 'null') {
        window.open(
        `${config.teamChatWithMessageUrl.replace('<USERS>', emails).replace('<TOPIC_NAME>',`Job%20${job.id}%20Chat`).replace('<CONTENT>',`Job ${job.id} has been confirmed. An email was sent and you can download a copy of the job card from here as well: ${config.clientApi}/dashboard/job_sheet?jobId=${job.id}${encodeURIComponent('&')}jobcard_token=${job.jobcard_token}`)}`,
        '_blank'
        );
      }
      else {
        sendNotification('error','Cannot open a team chat as there are no technicians are assigned to the job.', classes);
      }

      handleClose();
      refreshData();
    }

    function handleClose() {
      if(jobWidgetRef !== null && jobWidgetRef !== undefined &&
         jobWidgetRef.current !== null && jobWidgetRef.current !== undefined) {
           jobWidgetRef.current.closeWidgetMoreMenu();
         }
    }

    async function refreshData(copiedJobId) {
      const jobId = copiedJobId !== undefined && copiedJobId !== null && copiedJobId > 0 ?
                    copiedJobId :
                    locationState === undefined ? paramsId : locationState.jobId;

      if (jobId !== undefined && jobId > 0) {
          fetchData(jobId);
      }
    }

    const openEmail = () => {
      setEmailIsOpen(true);

      var emails = [];
      if (job.customer_email !== undefined &&
          job.customer_email !== null &&
          pattern.test(job.customer_email)) {
              emails.push(job.customer_email);
      }

      if (job.site_email !== undefined &&
          job.site_email !== null &&
          pattern.test(job.site_email)) {
              emails.push(job.site_email);
      }

      triggerOpenEmail({
        job_id: job.id,
        message: '',
        emails: emails,
        customer_name: selectedCustomer !== undefined && selectedCustomer !== null ? selectedCustomer.name : '',
        attach_certificate: true,
        attach_invoice_report: true,
        date: job.completed ? job.completed : '',
      });
    };

    function triggerOpenEmail(selectedEmail) {
      jobReportEmailsRef.current.openEmail(selectedEmail);
    }

    const generateCertificate = event => {
        window.open(`${config.clientApi}/reports/certificate.pdf?jobid=${job.id}&date=${job.completed}`,'_blank');
    }

    const copyJob = async() => {
      handleClose();
      setIsCopyingJob(true);
      const response = await ttAPI.copyJob(job.id);
      setIsCopyingJob(false);
      if (response > 0) {
          sendNotification('success', `Success - Job ${job.id} Copied into New Job ${response}.`, classes);
          history.push({pathname:`/app/job/edit/${response}`,
                      state:{jobId: response }
                    });
          refreshData(response);
          window.location.reload();
              /*window.open(
                  `${config.adminApi}/#/app/job/edit/${response}`,
                  '_blank'
                );*/

      }
      else {
          sendNotification('error', `Failed to copy Job ${job.id}.`, classes);
      }

    }

    const deleteJob = async() => {
      setIsDeletingJob(true);
      const response = await ttAPI.deleteJob(job.id);
      setIsDeletingJob(false);
      console.log(response);
      if (response.id > 0) {
          sendNotification('success', `Success - Job ${response.id} Deleted.`, classes);
          history.push({pathname:'/app/jobs',
                      state:{jobId: response, deleted: true }
                    });
      }
      else {
          sendNotification('error', `${response.error}`,classes);
      }

      handleClose();
    }

    function deleteJobConfirmation() {
      jobWidgetRef.current.closeWidgetMoreMenu();
      setOpenDeleteJobDialog(true);
    }

    const handleCloseDeleteJobDialog = () => {
      setOpenDeleteJobDialog(false);
    };

    const openCustomerInNewTab = () => {
        window.open(`${config.adminApi}/#/app/customer/edit/${selectedCustomer.id}`,'_blank');
    }

    const openSiteInNewTab = () => {
        window.open(`${config.adminApi}/#/app/site/edit/${selectedSite.id}`,'_blank');
    }

    function onClickWorkCompleteSwitch() {
        setJob({
          ...job,
          work_completed: job.work_completed === undefined || job.work_completed === null ? false : !job.work_completed
        });
    }

    function onClickConfirmedSwitch() {
        let newConfirmedValue = job.confirmed === undefined || job.confirmed === null ? false : !job.confirmed
        setCanSendJobSheet(!originalJobConfirmed && newConfirmedValue);
        setJob({
          ...job,
          confirmed: newConfirmedValue
        });
    }

    const downloadHistory = () => {
      jobWidgetRef.current.closeWidgetMoreMenu();
      window.open(`${config.clientApi}/reports/audit/job?id=${job.id}`,'_blank');
    }

    const downloadJSA = () => {
      window.open(`${config.clientApi}/report/form?is_jsa=true&is_pdf=true&jobid=${job.id}`,'_blank');
    }

    const sendJobSheet = () => {
        window.open(`${config.clientApi}/reports/job_sheet.pdf?jobId=${job.id}&isEmail=true&isJobConfirmed=true`,'_blank');
    }

    function onConfirmJobSuccess() {
        // only open link if the cached setup is set to true
        if (localStorage.getItem('auto_open_teams_link_after_job_confirmation') === 'true') {
            openTeamChatWithJobCardLink();
        }
        else {
            handleClose();
            refreshData();
        }
    }

    function onTestingScopesChanged(testingScopes) {
        selectTechniciansRef.current.updateTestingScopes(testingScopes);
        setTestScopesDirty(Math.random());
    }

    /*exact same set of functions used in BookJob.js, TODO: need to add to a Util class*/
    function onClickCopyExpiryInSiteRetestsList(expiringAssets, expiredMonth, oldTotalAssetsDue, totalAssetsDue) {
      //console.log('onRowSelectedInSiteRetestsList', expiringAssets, expiredMonth);
      //console.log('onClickCopyExpiryInSiteRetestsList', totalAssetsDue);

      var newInstructions = '';
      var estimatedTotalText = job.instructions.match(/Estimated total assets due:\s?[0-9]+/i);
      var totalRow = `Estimated total assets due: ${totalAssetsDue}.\n`;
      var newExpiryRow = `${expiringAssets} assets due to expire on ${expiredMonth}.\n`;

      if (estimatedTotalText !== undefined && estimatedTotalText !== null && estimatedTotalText[0] !== '') {
          var start = job.instructions.indexOf(estimatedTotalText[0]);
          var end = start + estimatedTotalText[0].length + 1;
          newInstructions = job.instructions.replace(job.instructions.slice(start, end),`${totalRow}${newExpiryRow}`.trim());
      }
      else {
          newInstructions = `${totalRow}${newExpiryRow}${job.instructions}`;
      }

      setJob({
        ...job,
        instructions: newInstructions,
      });
      createJobDetailsRef.current.updateInstructions(newInstructions);
    }

    function onClickRemoveExpiryInSiteRetestsList(expiringAssets, expiredMonth, totalAssetsDue) {
      //console.log('onRowSelectedInSiteRetestsList', expiringAssets, expiredMonth);
      var newInstructions = '';
      var estimatedTotalText = job.instructions.match(/Estimated total assets due:\s?[0-9]+/i);
      var totalRow = `Estimated total assets due: ${totalAssetsDue}.\n`;
      var expiryRowToRemove = `${expiringAssets} assets due to expire on ${expiredMonth}.\n`;
      if (estimatedTotalText !== undefined && estimatedTotalText !== null && estimatedTotalText[0] !== '') {
          var start = job.instructions.indexOf(estimatedTotalText[0]);
          var end = start + estimatedTotalText[0].length + 1;
          newInstructions = job.instructions.replace(job.instructions.slice(start, end),`${totalRow}`.trim()).replace(expiryRowToRemove, '');
      }
      else {
          newInstructions = `${totalRow}${job.instructions.replace(expiryRowToRemove, '')}`;
      }

      setJob({
        ...job,
        instructions: newInstructions,
      });
      createJobDetailsRef.current.updateInstructions(newInstructions);
    }

    function onClickCopyAllExpiryInSiteRetestsList(totalAssetsDue, data) {
      var newInstructions = job.instructions;
      var estimatedTotalText = job.instructions.match(/Estimated total assets due:\s?.*/i);

      let result = job.instructions.matchAll(/\s?[0-9]+\s?assets due to expire on.*/g);
      for (const match of result) {
          if (match !== null && match !== undefined && match[0] !== '') {
              newInstructions = newInstructions.replace(match[0],'');
          }
      }

      var newExpiryRows = '';
      for (const d of data) {
          newExpiryRows += `${d.assets} assets due to expire on ${d.expiry}.\n`;
      }

      var totalRow = `Estimated total assets due: ${totalAssetsDue}.\n`;


      if (estimatedTotalText !== undefined && estimatedTotalText !== null && estimatedTotalText[0] !== '') {
          var start = newInstructions.indexOf(estimatedTotalText[0]);
          var end = start + estimatedTotalText[0].length + 1;
          newInstructions = newInstructions.replace(newInstructions.slice(start, end),`${totalRow}${newExpiryRows}`.trim());
      }
      else {
          newInstructions = `${totalRow}${newExpiryRows}${newInstructions}`;
      }

      setJob({
        ...job,
        instructions: newInstructions,
      });
      createJobDetailsRef.current.updateInstructions(newInstructions);
    }

    function onClickRemoveAllExpiryInSiteRetestsList() {
        var newInstructions = job.instructions;
        var estimatedTotalText = job.instructions.match(/Estimated total assets due:\s?.*/i);
        if (estimatedTotalText !== undefined && estimatedTotalText !== null && estimatedTotalText[0] !== '') {
            newInstructions = newInstructions.replace(estimatedTotalText[0],'');
        }

        let result = newInstructions.matchAll(/\s?[0-9]+\s?assets due to expire on.*/g);
        for (const match of result) {
            if (match !== null && match !== undefined && match[0] !== '') {
                newInstructions = newInstructions.replace(match[0],'');
            }
        }

        setJob({
          ...job,
          instructions: newInstructions,
        });
        createJobDetailsRef.current.updateInstructions(newInstructions);
    }

    function containsCopiedInstructions(expiringAssets, expiredMonth) {
      return job.instructions === undefined || job.instructions === null ? '' : job.instructions.includes(`${expiringAssets} assets due to expire on ${expiredMonth}`);
    }

    function addTotalSelectedAssetsToInstructions(total) {
      var newInstructions = '';
      var estimatedTotalText = job.instructions.match(/Estimated total assets due:\s?[0-9]+/i);
      var totalRow = `Estimated total assets due: ${total}.\n`;

      if (estimatedTotalText !== undefined && estimatedTotalText !== null && estimatedTotalText[0] !== '') {
          var start = job.instructions.indexOf(estimatedTotalText[0]);
          var end = start + estimatedTotalText[0].length + 1;
          newInstructions = job.instructions.replace(job.instructions.slice(start, end),`${totalRow}`.trim());
      }
      else {
          newInstructions = `${totalRow}${job.instructions}`;
      }

      setJob({
        ...job,
        instructions: newInstructions,
      });
      createJobDetailsRef.current.updateInstructions(newInstructions);
    }

    /**/
    const handleCloseDeleteReportDialog = () => {
      setOpenDeleteReportDialog(false);
    };

    function onDeleteReport(jid, type) {
        setAboutToDeleteReport({jid: jid, type: type});
        setOpenDeleteReportDialog(true);
    }



    const onUploadReports = async () => {
        setIsUploading(true);
        if ( window.FileReader && window.FormData) {
           var formData = new FormData();

           var fileExisted = job.reports !== undefined && job.reports !== null ?
                               job.reports.map(doc => doc.name) : [];

           var filesToUpload = fileObjects.filter(fileToUpload => !fileExisted.includes(fileToUpload.name));
           for(var i=0;i<filesToUpload.length;i++){
               formData.append("reportFile", filesToUpload[i], filesToUpload[i].name);
           }
           const response = await ttAPI.uploadJobReports(job.id, formData);
           setIsUploading(false);
           console.log(response);
           if (response) {
               sendNotification('success', 'Success - Job Reports Uploaded.', classes);
               window.location.reload();
           }
           else {
               sendNotification('error', 'Error - Error Uploading Job Reports.', classes);
           }


       }

    }

    const checkReports = async (jobId) => {
        const status = await ttAPI.fetchTechnicalReportStatus(jobId);
        if (status) {
          setReportStatus({
            pdf: status.pdf,
            doc: status.doc,
          });
        } else {
          console.log('Failed to fetch the report status.');
        }
    };

    /*const getReportTypeFromName = (fileName) => {
      return fileName.split('.').pop().toLowerCase();
    };*/

    const deleteReport = async () => {
        const response = await ttAPI.deleteTechnicalReport(job.id, aboutToDeleteReport.type);
        if (response.success) {
            sendNotification('success', `Success - Report ${aboutToDeleteReport.type} Deleted.`, classes);
            setOpenDeleteReportDialog(false);
            window.location.reload();
        }
        else {
            sendNotification('error', `${response.error}`,classes);
        }
    }

  if (!mounted) {
    return null;
  }

  return (job && <>
    <Dialog open={openDeleteJobDialog} onClose={handleCloseDeleteJobDialog} disableBackdropClick={true}

        PaperProps={{
          style: {
            boxShadow: 'none',
          },
        }}
    >
      <DialogTitle className={classes.title}>Are you sure?</DialogTitle>
      <DialogContent>
        <DialogContentText>
           {`You are about to delete job ${job.id}.`}
        </DialogContentText>

      </DialogContent>
      <DialogActions>
          <Button onClick={handleCloseDeleteJobDialog}>
            Cancel
          </Button>
          <Button onClick={deleteJob} disabled={isDeletingJob}>
            {isDeletingJob && <span><CircularProgress size={25} color={'inherit'} /> Deleting...</span>}
            {!isDeletingJob && <span>DELETE</span>}
          </Button>
      </DialogActions>
    </Dialog>

    <Dialog open={openDeleteReportDialog} onClose={handleCloseDeleteReportDialog} disableBackdropClick={true}

        PaperProps={{
          style: {
            boxShadow: 'none',
          },
        }}
    >
      <DialogTitle className={classes.title}>Are you sure?</DialogTitle>
      <DialogContent>
        <DialogContentText>
           {`You are about to delete ${aboutToDeleteReport.type} report .`}
        </DialogContentText>

      </DialogContent>
      <DialogActions>
          <Button onClick={handleCloseDeleteReportDialog}>
            Cancel
          </Button>
          <Button onClick={deleteReport} disabled={isDeletingReport}>
            {isDeletingReport && <span><CircularProgress size={25} color={'inherit'} /> Deleting...</span>}
            {!isDeletingReport && <span>DELETE</span>}
          </Button>
      </DialogActions>
    </Dialog>

    <div className={classes.contentDiv}>

    {/*<div>{`job.id is ${job.id}`}</div>
    <div>{`job.customerId is ${job.customer_id}`}</div>
    <div>{`job.siteId is ${job.site_id}`}</div>
    <div>{`job.regionId is ${job.franchise_id}`}</div>
    <div>{`job.tag is ${job.tag}`}</div>
    <div>{`job.start is ${job.start}`}</div>
    <div>{`job.finish is ${job.finish}`}</div>
    <div>{`job.contact is ${job.contact}`}</div>
    <div>{`job.leader is ${job.leader}`}</div>
    <div>{`job.completed is ${job.completed}`}</div>*/}


        <Grid container spacing={4}>
          <Grid item xs={12} md={6} sm={6} style={{ alignSelf: 'flex-start' }}>

          <Box display={'flex'}
              justifyContent={'flex-end'}
              style={{marginBottom: '-20px', marginRight: '60px', marginTop: '20px'}}
          >
            <Tooltip title="Send Job Card Link in Teams">
              <ButtonBase
                  focusRipple
                  key="teams"
                  className={classes.teamsImage}
                  style={{
                     width: '50px',
                     position: 'fixed',
                     marginRight: originalJobConfirmed ? '140px' : '280px',
                     marginTop: '-5px',
                     zIndex: '11',
                     backgroundColor: 'white'
                  }}
                  onClick={openTeamChat}
                >
                <Badge  overlap="circle" badgeContent={<SendIcon className={classes.customBadgeSmall}/>}>
                  <img src={teams} alt="teams" className={classes.teamsImage} />
                </Badge>

              </ButtonBase>
            </Tooltip>

            <Tooltip title="Open Teams Chat">
              <ButtonBase
                  focusRipple
                  key="teams"
                  className={classes.teamsImage}
                  style={{
                     width: '50px',
                     position: 'fixed',
                     marginRight: originalJobConfirmed ? '80px' : '240px',
                     marginTop: '-5px',
                     zIndex: '10',
                     backgroundColor: 'white'
                  }}
                  onClick={openTeamChat}
                >
                  <img src={teams} alt="teams" className={classes.teamsImage} />


              </ButtonBase>
            </Tooltip>

              <Button style={{position: 'fixed', zIndex: '10',
                              marginRight: originalJobConfirmed ? '0' : '170px'}}
                  className={classes.saveEditJobButton}
                  variant="contained"
                  color={originalJobConfirmed ? "primary" : "default"}
                  disabled={disableSaveButton()}
                  onClick={handleFinish}
              >
              {isSaving && <span><CircularProgress size={25}/> Saving...</span>}
              {!isSaving && <span>Save</span>}
              </Button>

              {!originalJobConfirmed && <Button style={{position: 'fixed', zIndex: '10'}}
                  className={classes.saveEditJobButton}
                  variant="contained"
                  color="primary"
                  disabled={disableConfirmButton()}
                  onClick={handleConfirmJob}
              >
              {isConfirming && <span><CircularProgress size={25}/> Saving and Confirming...</span>}
              {!isConfirming && <span>Save & Confirm</span>}
              </Button>}

          </Box>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <Widget
                title={`EDIT - Job ${job.id}`}
                upperTitle
                ref={jobWidgetRef}
                className={classes.card}
                bodyClass={classes.fullHeightBody}
                menuItems={<div style={{margin: 'auto 10px'}}>
                               {/* Group 1: Job Management */}
                               <div className={classes.menuSubtitle}>
                                  <hr className={classes.submenuLeftLine}/>
                                  <Typography variant="subtitle2" className={classes.menuSubtitleStyle}>Job Management</Typography>
                                  <hr className={classes.submenuLine}/>
                               </div>
                                  {((job.confirmed !== undefined && job.confirmed !== null && job.confirmed) && (job.completed === undefined || job.completed === null))  &&
                                  <MenuItem onClick={handleOpenCompleteJob}>
                                    <AssignmentTurnedInIcon/>&nbsp;<Typography>Close & Invoice</Typography>
                                 </MenuItem>}
                                {(job.confirmed === undefined || job.confirmed === null || !job.confirmed)  &&
                                <MenuItem onClick={handleOpenConfirmJob}>
                                  <CheckIcon/>&nbsp;<Typography>Confirm</Typography>
                                </MenuItem>}
                                <MenuItem onClick={copyJob}>
                                  <FileCopyIcon/>&nbsp;
                                      {!isCopyingJob && <Typography> Copy Job</Typography>}
                                      {isCopyingJob && <><CircularProgress size={25}/><Typography>Copying Job...</Typography></>}
                                </MenuItem>
                                <MenuItem onClick={deleteJobConfirmation}>
                                  <DeleteForeverIcon/>&nbsp;
                                      {!isDeletingJob && <Typography> Delete Job</Typography>}
                                      {isDeletingJob && <><CircularProgress size={25}/><Typography>Deleting Job...</Typography></>}
                                </MenuItem>
                                <MenuItem onClick={downloadHistory}>
                                  <HistoryIcon/>&nbsp;<Typography>Download History</Typography>
                                </MenuItem>
                                {((job.confirmed !== undefined && job.confirmed !== null && job.confirmed) && ((job.completed !== undefined && job.completed !== null) || (job.work_completed !== undefined && job.work_completed !== null && job.work_completed)))  &&
                                <MenuItem onClick={handleOpenReopenJob}>
                                  <ReplayIcon/>&nbsp;<Typography>Reopen</Typography>
                               </MenuItem>}

                               {/* Group 2: After Work Completed */}
                               <div className={classes.menuSubtitle}>
                                  <hr className={classes.submenuLeftLine}/>
                                  <Typography variant="subtitle2" className={classes.menuSubtitleStyle}>After Work Completed</Typography>
                                  <hr className={classes.submenuLine}/>
                               </div>
                                 <MenuItem onClick={downloadJobIssuesReport}>
                                   <GetAppIcon/>&nbsp;<Typography>Download Above and Beyond Report</Typography>
                                 </MenuItem>
                                 <MenuItem onClick={downloadFailedReport}>
                                   <GetAppIcon/>&nbsp;<Typography>Download Failed Report</Typography>
                                 </MenuItem>
                               <MenuItem onClick={downloadJSA}>
                                 <HistoryIcon/>&nbsp;<Typography>Download JSA</Typography>
                               </MenuItem>

                               {/* Group 3: Invoicing */}
                               <div className={classes.menuSubtitle}>
                                  <hr className={classes.submenuLeftLine}/>
                                  <Typography variant="subtitle2" className={classes.menuSubtitleStyle}>Invoicing</Typography>
                                  <hr className={classes.submenuLine}/>
                               </div>
                               <MenuItem onClick={downloadInvoicePdf}>
                                 <ReceiptIcon/>&nbsp;<Typography>Invoice PDF</Typography>
                               </MenuItem>
                               <MenuItem onClick={openInvoiceSummary}>
                                 <GetAppIcon/>&nbsp;<Typography>Invoicing Summary</Typography>
                               </MenuItem>

                               {/* Group 4: After Invoiced */}
                               {((job.confirmed !== undefined && job.confirmed !== null && job.confirmed) && job.completed !== undefined && job.completed !== null)  &&
                                 <>
                                 <div className={classes.menuSubtitle}>
                                    <hr className={classes.submenuLeftLine}/>
                                    <Typography variant="subtitle2" className={classes.menuSubtitleStyle}>After Invoiced</Typography>
                                    <hr className={classes.submenuLine}/>
                                 </div>
                                 <MenuItem onClick={openEmail}>
                                   <SendIcon/>&nbsp;<Typography>Email Report</Typography>
                                 </MenuItem>
                                   <MenuItem onClick={generateCertificate}>
                                     <CardMembershipIcon/>&nbsp;<Typography>Generate Certificate</Typography>
                                   </MenuItem>
                                 </>
                               }

                                {/* Group 5: Assets */}
                                <div className={classes.menuSubtitle}>
                                   <hr className={classes.submenuLeftLine}/>
                                   <Typography variant="subtitle2" className={classes.menuSubtitleStyle}>Assets</Typography>
                                   <hr className={classes.submenuLine}/>
                                </div>
                                <MenuItem onClick={downloadCustomerAssetsCSV}>
                                   <PageviewIcon/>&nbsp;<Typography>Customer Assets CSV</Typography>
                                </MenuItem>
                                <MenuItem onClick={openViewAssets}>
                                   <ListAltIcon/>&nbsp;<Typography>View Assets</Typography>
                                </MenuItem>


                                {/* Group 6: Communication */}
                                <div className={classes.menuSubtitle}>
                                   <hr className={classes.submenuLeftLine}/>
                                   <Typography variant="subtitle2" className={classes.menuSubtitleStyle}>Communication</Typography>
                                   <hr className={classes.submenuLine}/>
                                </div>
                                <MenuItem onClick={openTeamChat}>
                                  <ChatIcon/>&nbsp;<Typography>Open Chat</Typography>
                                </MenuItem>
                                {(job.confirmed !== undefined && job.confirmed !== null && job.confirmed)  &&
                                <MenuItem onClick={openTeamChatWithJobCardLink}>
                                  <ChatIcon/>&nbsp;<Typography>Send Job Card Link in Teams</Typography>
                                </MenuItem>
                                }

                           </div>
                         }>

              <div className={classes.inline} style={{marginBottom: '20px'}}>
                  <SelectCustomer labelName="Customer"
                                    selectedCustomer={selectedCustomer}
                                    onSelect={onSelectCustomer}
                                    onFormUpdated={onSelectCustomerFormUpdated}/>
                  <IconButton color="primary"
                              aria-label="open edit customer in new tab"
                              component="span"
                              onClick={openCustomerInNewTab}>
                      <EditIcon />
                  </IconButton>
              </div>

              <div style={{marginBottom: '20px'}}>
                  <SelectSite labelName="Site"
                              selectedSite={selectedSite}
                              customerId={selectedCustomer !== undefined ? selectedCustomer.id : -1}
                              onSelect={onSelectSite}
                              onFormUpdated={onSelectSiteFormUpdated}/>
              </div>
              {/*<div className={classes.inline}>
                  <SelectSite labelName="Site"
                              selectedSite={selectedSite}
                              customerId={selectedCustomer !== undefined ? selectedCustomer.id : -1}
                              onSelect={onSelectSite}
                              onFormUpdated={onSelectSiteFormUpdated}/>
                  <IconButton color="primary"
                              aria-label="open edit site in new tab"
                              component="span"
                              onClick={openSiteInNewTab}>
                      <EditIcon />
                  </IconButton>
              </div>*/}


              {selectedCustomer !== undefined && selectedCustomer !== null &&
               selectedSite !== undefined && selectedSite !== null &&
               <JobDetails ref={createJobDetailsRef}
                          createdJob={job}
                          selectedCustomer={selectedCustomer}
                          onFormUpdated={onCreateJobDetailsFormUpdated}
                          onJobDetailsUpdated={onCreateJobDetailsUpdated}
                          onJobDetailsCreated={onJobDetailsCreated}
                          onRegionSelected={onRegionSelected}
                          onIsInRegionSelected={onIsInRegionSelected}
                          onTestingScopesChanged={onTestingScopesChanged}
                          getSiteName={getSiteName}
                          isEditJob={true}
                          />}
              {/*selectedCustomer !== undefined && selectedCustomer !== null &&
                selectedCustomer.require_vaccination_proof &&
                <div style={{color: '#f44336', marginTop: '-10px', marginBottom: '10px'}}>Proof of vaccination required!</div>*/}
              <SelectTechnicians ref={selectTechniciansRef}
                                 createdJob={job}
                                 onFormUpdated={onSelectTechniciansFormUpdated}
                                 workers={workers}
                                 onTechniciansSelected={onTechniciansSelected}
                                 onLeaderSelected={onLeaderSelected}
                                 dirty={testScopesDirty}
                                 showQualifiedTechWarning={true}
                                 showQualifiedTechWarning={displaySiteAssetsExpiryByMonth && qualifiedTechWarningRequired}/>

             <div className={classes.inline}>
             {(job.id !== undefined && job.id !== null && job.id > 0) &&
               originalJobConfirmed &&
               <Box display={"flex"} alignItems={"center"} style={{marginBottom: '20px', marginTop: '20px'}}>
                 <Typography weight={"medium"}>
                     Confirmed
                 </Typography>
                 <Switch color={"primary"} checked={job.confirmed}
                         onClick={onClickConfirmedSwitch}
                         disabled={((job.completed !== undefined && job.completed !== null) || (job.work_completed !== undefined && job.work_completed !== null && job.work_completed))}/>
             </Box>}

             {(job.id !== undefined && job.id !== null && job.id > 0) && originalJobConfirmed &&
               <Box display={"flex"} alignItems={"center"} style={{marginBottom: '20px', marginTop: '20px'}}>
                 <Typography weight={"medium"}>
                     Work Completed
                 </Typography>
                 <Switch color={"primary"} checked={job.work_completed}
                         onClick={onClickWorkCompleteSwitch} />
             </Box>}

             {(job.id !== undefined && job.id !== null && job.id > 0) && originalJobConfirmed &&
              <div className={classes.calendars} style={{marginTop: '20px'}}>
                  <TextField
                    id="complete"
                    ref={completeRef}
                    label="Job Closed & Invoiced"
                    className={classnames({
                    'textField': true,
                    'calenderField': true,
                    [classes.calendarFocused]: completeFocused
                  })}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      startAdornment: (
                          <InputAdornment position="start">
                            <CalendarTodayIcon />
                          </InputAdornment>
                        ),
                        inputComponent: () =>
                        <DatePicker
                        ref={completeCalendarRef}
                        className={classes.textField}
                        selected={selectedCompleted}
                        onSelect={handleSelectCompleted}
                        onChange={handleChangeCompleted}
                        onFocus={focusComplete}
                        onClickOutside={blurComplete}
                        onKeyDown={handleCompleteKeyPress}
                        locale="en-NZ"
                        timeIntervals={30}
                        dateFormat="dd/MM/yyyy"
                        />
                      }}
                      />
                  {/*<MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDateTimePicker
                        autoOk={true}
                          variant="inline"
                        inputVariant="outlined"
                        ampm={false}
                        required={true}
                        label="Completed"
                        value={selectedCompleted}
                        onChange={handleChangeCompleted}
                        onError={console.log}
                        format="dd/MM/yyyy HH:mm"
                        size="small"
                      />
                  </MuiPickersUtilsProvider>*/}

                  </div>}
              </div>
              <div className={classes.bottomMenu}>
                  <div>
                  <Box
                      display={'flex'}
                      justifyContent={'flex-end'}
                      style={{height: '50px', paddingTop: '10px'}}
                  >
                  <Tooltip title="Send Job Card Link in Teams">
                    <ButtonBase
                        focusRipple
                        key="teams"
                        className={classes.teamsImage}
                        style={{
                           width: '50px',
                        }}
                        onClick={openTeamChat}
                      >
                      <Badge  overlap="circle" badgeContent={<SendIcon className={classes.customBadgeSmall}/>}>
                        <img src={teams} alt="teams" className={classes.teamsImage} />
                      </Badge>

                    </ButtonBase>
                  </Tooltip>

                  <Tooltip title="Open Teams Chat">
                    <ButtonBase
                        focusRipple
                        key="teams"
                        className={classes.teamsImage}
                        style={{
                           width: '50px',
                        }}
                        onClick={openTeamChat}
                      >
                        <img src={teams} alt="teams" className={classes.teamsImage} />


                    </ButtonBase>
                  </Tooltip>
                      <Button
                          className={classes.saveEditJobButton}
                          variant="contained"
                          color={originalJobConfirmed ? "primary" : "default"}
                          disabled={disableSaveButton()}
                          onClick={handleFinish}
                      >
                      {isSaving && <span><CircularProgress size={25}/> Saving...</span>}
                      {!isSaving && <span>Save</span>}
                      </Button>

                      {!originalJobConfirmed && <Button className={classes.saveEditJobButton}
                          style={{marginLeft: '10px'}}
                          variant="contained"
                          color="primary"
                          disabled={disableConfirmButton()}
                          onClick={handleConfirmJob}
                      >
                      {isConfirming && <span><CircularProgress size={25}/> Saving and confirming...</span>}
                      {!isConfirming && <span>Save & Confirm</span>}
                      </Button>}
                  </Box>
                  </div>
              </div>

            </Widget>
            {job.work_completed && hasThermal &&

                <Widget
                  title="Report (for Thermal ONLY)"
                  upperTitle
                  className={classes.card}
                  bodyClass={classes.fullHeightBody}
                  disableWidgetMenu
                >
                  <div className={classes.reportsDisplay}>
                  <div>
                  {(reportStatus.pdf || reportStatus.doc) && (
                          <>
                            {reportStatus.pdf && (
                              <Box>
                                <Link
                                  href={`${config.googleFileStorageUrl}${job.id}_report.pdf`}
                                  target="_blank"
                                  underline="none"
                                  color="#fff"
                                >
                                  <Button>
                                    <Box mr={1} display={'flex'}>
                                      <PictureAsPdfIcon />
                                    </Box>
                                    PDF Report
                                    <Box mr={1} display={'flex'}>
                                      <GetAppIcon />
                                    </Box>
                                  </Button>
                                </Link>
                                <IconButton
                                  color="inherit"
                                  onClick={() => onDeleteReport(job.id, 'pdf')}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Box>
                            )}
                            {reportStatus.doc && (
                              <Box>
                                <Link
                                  href={`${config.googleFileStorageUrl}${job.id}_report.docx`}
                                  target="_blank"
                                  underline="none"
                                  color="#fff"
                                >
                                  <Button>
                                    <Box mr={1} display={'flex'}>
                                      <DescriptionIcon />
                                    </Box>
                                    Word Report
                                    <Box mr={1} display={'flex'}>
                                      <GetAppIcon />
                                    </Box>
                                  </Button>
                                </Link>
                                <IconButton
                                  color="inherit"
                                  onClick={() => onDeleteReport(job.id, 'docx')}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Box>
                            )}
                            <br />
                          </>
                          )}

                  </div>
                  <div>


                  <DropzoneArea
                            filesLimit={reportsLimit}
                            showFileNames={true}
                            acceptedFiles={[
                              'application/pdf',
                              'application/msword',
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                            ]}
                            dropzoneText={"Drag and drop PDF/DOCX report here or click to select files."}
                            onChange={ newFileObjs => {setFileObjects(newFileObjs); }}
                            onDelete={ newFileObjs => {setFileObjects([]); }}
                            maxFileSize={104857600}
                          />

                          {fileObjects !== undefined && fileObjects !== null &&
                            fileObjects.length > 0 &&
                            <Button onClick={onUploadReports}>
                              <Box>
                                  <PublishIcon />
                              </Box>
                              {isUploading && <span><CircularProgress size={25}/> Uploading job reports...</span>}
                              {!isUploading && <span>Upload Job Report</span>}
                          </Button>}
                  </div>
                  </div>

                  </Widget>
                }
                </div>
            </Grid>

          <Grid item xs={12} md={6} sm={6}>
            <Grid container spacing={4}>
            <Grid item xs={12} md={12} sm={12}>
              { displaySiteAssetsExpiryByMonth && job && job.site_id  &&

                <SiteRetests ref={siteRetestsRef} site_id={job.site_id} customer_id={job.customer_id}
                           id={locationState === undefined ? paramsId : locationState.retestId}
                           onCopyExpiry={onClickCopyExpiryInSiteRetestsList}
                           onRemoveExpiry={onClickRemoveExpiryInSiteRetestsList}
                           onCopyAllExpiry={onClickCopyAllExpiryInSiteRetestsList}
                           onRemoveAllExpiry={onClickRemoveAllExpiryInSiteRetestsList}
                           onShowCopyExpiryButton={containsCopiedInstructions}
                           onAddTotalSelectedToInstructions={addTotalSelectedAssetsToInstructions}
                           onQualifiedTechWarningRequiredChange={setQualifiedTechWarningRequired}/>
                         }
            </Grid>
            {selectedSite && selectedSite.id > 0 && <Grid item xs={12} md={12} sm={12}>
              <Widget
               className={classes.formDisplay}
               disableWidgetMenu noHeader>
               <AppBar position="static" color="default" style={{ marginTop: 10 }}>
                 <Tabs value={siteTabValue}
                       onChange={handleSiteTabChange}
                       indicatorColor="primary"
                       textColor="primary"
                       variant="fullWidth">
                   <Tab {...a11yProps(0)} label="SITE NOTES"
                                          value={0}/>
                   <Tab {...a11yProps(1)} label="HISTORY"
                                         value={1}/>
                   <Tab {...a11yProps(2)} label="SITE DETAILS"
                                          value={2}/>
                 </Tabs>
               </AppBar>
               {/*<TabPanel value={siteTabValue} index={0}>
                  <UpdateSite key={selectedSite.id} isNotesOnly={true} createdSite={selectedSite} inTab={true} onUpdateSuccess={refreshData}/>
                </TabPanel>
                <TabPanel value={siteTabValue} index={1}>
                  <UpdateSite key={selectedSite.id} createdSite={selectedSite} inTab={true} onUpdateSuccess={refreshData}/>
                </TabPanel>*/}
                <div
                  role="tabpanel"
                  id="simple-tabpanel-site-0"
                  aria-labelledby="simple-tab-site-0"
                >
                  {siteTabValue === 0 && (
                    <Box p={3}>
                      <Typography component="div">
                      <UpdateSite key={selectedSite.id} isNotesOnly={true} createdSite={selectedSite} inTab={true} onUpdateSuccess={refreshData}/>
                      </Typography>
                    </Box>
                  )}
                </div>

                <div
                  role="tabpanel"
                  id="simple-tabpanel-1"
                  aria-labelledby="simple-tab-1"
                >
                  {siteTabValue === 1 && (
                    <Box p={3}>
                      <Typography component="div">
                       <JobHistories key={selectedSite.id} jobId={oldJobId}/>
                      </Typography>
                    </Box>
                  )}
                </div>

                <div
                  role="tabpanel"
                  id="simple-tabpanel-site-1"
                  aria-labelledby="simple-tab-site-1"
                >
                  {siteTabValue === 2 && (
                    <Box p={3}>
                      <Typography component="div">
                      <UpdateSite key={selectedSite.id} createdSite={selectedSite} inTab={true} onUpdateSuccess={refreshData}/>
                      </Typography>
                    </Box>
                  )}
                </div>

              </Widget>
            </Grid>}
            {selectedCustomer && selectedCustomer.id > 0 && <Grid item xs={12} md={12} sm={12}>
              <Widget
               className={classes.formDisplay}
               disableWidgetMenu noHeader>
               <AppBar position="static" color="default" style={{ marginTop: 10 }}>
                 <Tabs value={customerTabValue}
                       onChange={handleCustomerTabChange}
                       indicatorColor="primary"
                       textColor="primary"
                       variant="fullWidth">
                   <Tab {...a11yProps(0)} label="CUSTOMER NOTES"
                                          value={0}/>
                   <Tab {...a11yProps(1)} label="CUSTOMER DETAILS"
                                          value={1}/>
                 </Tabs>
               </AppBar>
               {/*<TabPanel value={customerTabValue} index={0}>
                  <UpdateCustomer key={selectedCustomer.id} isNotesOnly={true} createdCustomer={selectedCustomer} inTab={true} onUpdateSuccess={refreshData}/>
                </TabPanel>
                <TabPanel value={customerTabValue} index={1}>
                  <UpdateCustomer key={selectedCustomer.id} createdCustomer={selectedCustomer} inTab={true} onUpdateSuccess={refreshData}/>
                </TabPanel>*/}

                <div
                  role="tabpanel"
                  id="simple-tabpanel-customer-0"
                  aria-labelledby="simple-tab-customer-0"
                >
                  {customerTabValue === 0 && (
                    <Box p={3}>
                      <Typography component="div">
                      <UpdateCustomer key={selectedCustomer.id} isNotesOnly={true} createdCustomer={selectedCustomer} inTab={true} onUpdateSuccess={refreshData}/>
                      </Typography>
                    </Box>
                  )}
                </div>

                <div
                  role="tabpanel"
                  id="simple-tabpanel-customer-1"
                  aria-labelledby="simple-tab-customer-1"
                >
                  {customerTabValue === 1 && (
                    <Box p={3}>
                      <Typography component="div">
                      <UpdateCustomer key={selectedCustomer.id} createdCustomer={selectedCustomer} inTab={true} onUpdateSuccess={refreshData}/>
                      </Typography>
                    </Box>
                  )}
                </div>

              </Widget>
            </Grid>}
            </Grid>
          </Grid>
        </Grid>

        <JobConfirmation ref={jobConfirmationRef}
                         closeMenu={handleClose}
                         onConfirmationSuccess={onConfirmJobSuccess}/>
        <JobCompletion ref={jobCompletionRef}
                       closeMenu={handleClose}
                       onCompleteSuccess={refreshData}/>
        <JobReopen ref={jobReopenRef}
                      closeMenu={handleClose}
                      onReopenSuccess={refreshData}/>
        <JobReportEmail ref={jobReportEmailsRef}
                       email={email}
                       closeMenu={handleClose}/>
        <CustomerDownloadCSVConfirmation ref={customerDownloadCSVConfirmationRef}
                         closeMenu={handleClose}/>

    </div></>
  );
//}
});
export default EditJob;
